export const myInsightsQueryKeys = {
  all: () => ['my-insights'] as const,
  summary: () => [...myInsightsQueryKeys.all(), 'summary'] as const,
  sessions: {
    list: (page: number, limit: number, q: string) =>
      [...myInsightsQueryKeys.all(), 'sessions', 'list', page, limit, q] as const,
    all: (q: string) => [...myInsightsQueryKeys.all(), 'sessions', 'all', q] as const,
    byDate: (date: string) =>
      [...myInsightsQueryKeys.all(), 'sessions', 'byDate', date] as const,
  },
  sessionDetail: {
    ppg: (id: string, limit: number) =>
      [...myInsightsQueryKeys.all(), 'session', id, 'ppg', limit] as const,
    eeg: (id: string, limit: number) =>
      [...myInsightsQueryKeys.all(), 'session', id, 'eeg', limit] as const,
  },
};
